// Any user generated links with target=_blank can be hijacked
// and turned into phishing attempts. Learn more here:
// http://danielstjules.github.io/blankshield/
//
// Test by inserting this link anywhere in the dom and clicking it:
// <a class="button button-primary mlr-auto" target="_blank" href="http://www.danielstjules.com/github/blankshield-demo-attack.html">Not Safe</a>
//
// If blankshield works, your original tab will remain intact. If it fails, your tab will refresh to point to a phishing demo
if (window.blankshield) {
  blankshield($('a[target=_blank]'));
}



// WEBPACK FOOTER //
// ./javascripts/components/legacy/init/blankshield.js